// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Vwp4h","clinicsSelect":"styles_clinicsSelect__2RO4o"};